import * as types from './mutation-types'
import Vue from 'vue'

const state = {
  modalAlertFooter: {
    active: false,
    text: '',
    propData: {}
  }
}

const getters = {
  modalAlertFooterShow: state => state.modalAlertFooter.active,
  modalAlertFooterText: state => state.modalAlertFooter.text,
  modalAlertFooterPropData: state => state.modalAlertFooter.propData
}

const actions = {
  async [types.SET_MODAL_ALERT_FOOTER](
    { commit },
    payload = { active: true, text: '', propData: {} }
  ) {
    commit(types.SET_MODAL_ALERT_FOOTER, payload)
  }
}

const mutations = {
  [types.SET_MODAL_ALERT_FOOTER](state, result) {
    Vue.set(state, 'modalAlertFooter', result)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
